import { ADD_PAYLOAD, DELETE_PAYLOAD, EDIT_PAYLOAD, EDIT_PAYLOAD_FAMILYGROUP, EMPTY_PAYLOAD_FAMILYGROUP, SEARCH_PAYLOAD } from '../Types/types'
import { iInitialStateDuType } from "../../Interfaces/IDuType";
import { iInitialStateFamilyGroup } from "../../Interfaces/IFamilyGroup";

export interface initialState {
  data: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state: initialState = { data: null }, action: any) {
  switch (action.type) {
    case ADD_PAYLOAD:
      return {
        ...state,
        data: action.payload,
      }
    case EDIT_PAYLOAD:
      return {
        ...iInitialStateDuType,
        data: action.payload,
      }
    case SEARCH_PAYLOAD: //This is for DuType Container Dropdown change 
      return {
        ...iInitialStateDuType,
        data: action.payload,
      }
    case EDIT_PAYLOAD_FAMILYGROUP:
      return {
        ...iInitialStateFamilyGroup,
        data: action.payload,
      }
    case EMPTY_PAYLOAD_FAMILYGROUP:
      return {
        data: null
      }
    case DELETE_PAYLOAD:
      return {
        ...state,
        data: action.payload,
      }
    default:
      return state
  }
}
